import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';
import InputText from '../../../inputs/InputText';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem 0;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledInputText = styled(InputText)`
  > p {
    margin-top: 0.5rem;
  }
`;

export const InfoText = styled(Typography)`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.greyDark};
  line-height: 1.4;
  margin-top: -0.5rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }
`;

export const CancelButton = styled(MainButton)`
  min-width: 10rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;

export const SubmitButton = styled(MainButton)`
  min-width: 10rem;

  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }
`;
